import React from 'react';

const MEDALS = ['🥇', '🥈', '🥉'];

const BattleResultScreen = ({ roomData, onBack }) => {
  const players = Object.values(roomData.players || {})
    .sort((a, b) => b.score - a.score);

  return (
    <div className="glass-card" style={{ maxWidth: '480px', width: '95%' }}>
      <h2 style={{ color: '#2c3e50', marginBottom: '4px' }}>🏆 結果発表</h2>
      <p style={{ color: '#95a5a6', fontSize: '0.85rem', marginBottom: '24px' }}>
        全{roomData.questionCount}問終了！
      </p>

      {/* 表彰台 */}
      <div style={{ width: '100%', marginBottom: '24px' }}>
        {players.map((p, i) => (
          <div key={i} style={{
            display: 'flex', alignItems: 'center', gap: '12px',
            padding: '14px 18px', marginBottom: '8px', borderRadius: '16px',
            background: i === 0 ? '#fef9e7' : '#f8f9fa',
            border: i === 0 ? '2px solid #e67e22' : '2px solid #e1e8ed',
          }}>
            <span style={{ fontSize: '1.8rem', minWidth: '36px' }}>
              {MEDALS[i] || `${i + 1}位`}
            </span>
            <div style={{ flex: 1 }}>
              <div style={{ fontWeight: 'bold', color: '#2c3e50', fontSize: '1rem' }}>
                {p.name}
                {p.isHost && <span style={{ fontSize: '0.7rem', color: '#e67e22', marginLeft: '6px' }}>HOST</span>}
              </div>
            </div>
            <div style={{ fontWeight: '900', fontSize: '1.4rem', color: i === 0 ? '#e67e22' : '#7f8c8d' }}>
              {p.score || 0}pt
            </div>
          </div>
        ))}
      </div>

      <button className="playful-btn" style={{ background: '#e67e22', width: '100%' }} onClick={onBack}>
        タイトルに戻る
      </button>
    </div>
  );
};

export default BattleResultScreen;